import { Controller } from 'stimulus';
import gsap from 'gsap';

class ContactBackgroundController extends Controller {
  connect() {
    this.tooltipIsVisible = true;
    this.isMobile = window.innerWidth < 768;
    this.onWindowScroll();
  }

  onWindowScroll() {
    if (!this.isMobile) {
      this.toggleTooltip(true);
      return;
    }

    if (window.scrollY >= 30 && this.tooltipIsVisible) {
      this.toggleTooltip(false);
    } else if (window.scrollY < 30 && !this.tooltipIsVisible) {
      this.toggleTooltip(true);
    }
  }

  onWindowResize() {
    this.isMobile = window.innerWidth < 768;
    this.onWindowScroll();
  }

  toggleTooltip(state) {
    this.tooltipIsVisible = state;

    gsap.to(this.tooltipTarget, {
      opacity: state ? 1 : 0,
      duration: 0.4,
    });
  }
}

ContactBackgroundController.targets = [
  'tooltip',
];

export default ContactBackgroundController;
